import { useEffect, useState } from "react"
import { _FixedAsset, _single } from "../../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../../core/services/dataBean/useDataBean"
import { AccountEditor } from "../../editor/AccountEditor"
import { BasicPage } from "../../theme/Component/BasicPage"
import { BasicTable, MASK_NUMBER } from "../../theme/Component/BasicTable"
import { ListMenu } from "../../theme/Component/ListMenu"
import { BasicButton } from "../../theme/Component/BasicButton"
import { Modal } from "../../theme/Component/Modal"
import { toast } from "react-toastify"
import { FixedAssetLineEditor } from "../../editor/fixedAssets/FixedAssetLine.editor"
import { BranListForFixedAssetLineEditor } from "../../editor/fixedAssets/BranListForFixedAssetLine.editor"
import { BasicSwitch } from "../../theme/Component/BasicSwitch"
import { InputMoney } from "../../theme/Input/InputMoney"
import { InputDate } from "../../theme/Input/InputDate"
import { SelectStoreEditor } from "../../contract/etapa-contrato/contrac/ublinvoice/SelectStore.editor"
import { FixedAssetItem } from "../../contract/etapa-contrato/contrac/ublinvoice/FixedAssetItem/FixedAssetItem"
import usePaginator from "../../theme/Component/usePaginator"

export const FixedAsset = () => {

    const { instance, setBean, setLista, bean, lista } = useDataBean(_FixedAsset);
    const [response, setResponse] = useState<any>({});
    const paginador = usePaginator();

    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalItems, setModalItems] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    const getLista = () => {
        instance.getFixedAssetCatalog(response.IDFixedAsset, response.Prefix, response.IDAccount, paginador.page, 15).then(
            (resp) => {
                paginador.setPages(resp.NumberOfPages);
                resp.List.forEach(element => {
                    element.DataBeanProperties.AdquisitionDocEntity = `${element.DataBeanProperties.Consecutive ? `${element.DataBeanProperties.Mnemonic} - ${element.DataBeanProperties.Consecutive} - ${element.DataBeanProperties.InitDate}` : ""}`
                });
                setLista(resp.List)
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const head = [
        { title: 'ID', property: 'IDFixedAsset', visible: true, mask: MASK_NUMBER },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Documento de Adquisición', property: 'AdquisitionDocEntity', visible: true },
        { title: 'Línea/Grupo de Activos', property: 'FixedAssetLineName', visible: true },
        { title: 'Cuenta Servicio Clasificación', property: 'BrandStrName', visible: true },
        { title: 'Proveedor', property: 'SupplierName', visible: true },
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar Propiedades de Activo Fijo', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "view": true, "name": `Editar Activo Fijo ${bean.Description}` }) } },
            { titulo: 'Items de Activo Fijo', icono: 'ri-list-ordered', visible: true, evento: () => { setModalItems({ ...modalItems, "view": true, "name": `Items de Activo Fijo ${bean.Description}` }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const updateItem = () => {
        instance.updateFixedAsset(bean).then(
            (resp) => {
                setModal({ ...modal, "view": false });
                getLista();
            }
        ).catch(
            err => {
                console.error(err);
                toast.error("Algo Salio Mal");
            }
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
        } else {
            updateItem();
        }
    }

    const validateForm = () => {
        const requiredFields = [
            "Description", "Mark", "IDStore", "Measurement",
            "FixedAssetAccountantID", "LiveTime"
        ];
        let missing = [];

        for (let field of requiredFields) {
            if (!bean[field]) {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    return (
        <BasicPage titulo="Catálogo de Activos Fijos">
            <div className="row">
                <div className="col-md-6">
                    <label>ID de Activo Fijo a Buscar</label>
                    <input type="number" className="form-control" value={response.IDFixedAsset} onChange={(e) => { setResponse({ ...response, "IDFixedAsset": parseInt(e.target.value) }) }} />
                </div>
                <div className="col-md-6">
                    <label>Búsqueda por Texto</label>
                    <input type="string" className="form-control" value={response.Prefix} onChange={(e) => { setResponse({ ...response, "Prefix": e.target.value }) }} />
                </div>
                <div className="col-md-6">
                    <AccountEditor idAccount={response.IDAccount} label="Proveedor Seleccionado" onChange={(e) => { setResponse({ ...response, "IDAccount": e.IDAccount }) }} />
                </div>
                <div className="col-md-6 mt-4">
                    <BasicButton eventClick={getLista} icon="ri-search-line" children={"Buscar"} />
                </div>
                <div className="col-md-12">
                    <BasicTable
                        body={lista}
                        head={head}
                        rowSet={setBean}
                        listButtons={listaBotones()}
                        pageTop={paginador.page}
                        next={paginador.next}
                        back={paginador.back}
                        records={paginador}
                    />
                </div>

                <div className="col-md-12">

                    <Modal modal={modal} updateModal={setModal} eventModal={validateData} >
                        <div className="row">
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('Description') ? 'has-error' : ''}`} >Nombre Activo</label>
                                <input type="text" className="form-control" name="Description" value={bean.Description} onChange={(e) => { setBean({ ...bean, "Description": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('Mark') ? 'has-error' : ''}`} >Marca</label>
                                <input type="text" className="form-control" name="Mark" value={bean.Mark} onChange={(e) => { setBean({ ...bean, "Mark": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('InitialQuantity') ? 'has-error' : ''}`} >Cantidad</label>
                                <input readOnly type="number" disabled={bean.IDUBLInvoice} className="form-control" name="InitialQuantity" value={bean.InitialQuantity} onChange={(e) => { setBean({ ...bean, "InitialQuantity": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('AssetValue') ? 'has-error' : ''}`}>Valor Unitario</label>
                                <InputMoney _label=" " readonly={true} onChange={(e) => { setBean({ ...bean, "AssetValue": e }) }} _value={bean.AssetValue} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('IvaValue') ? 'has-error' : ''}`}>IVA %</label>
                                <input type="number" disabled={true} className="form-control" name="IvaValue" value={bean.IvaValue} onChange={(e) => { setBean({ ...bean, "IvaValue": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('AliveValue') ? 'has-error' : ''}`}>Valor Total</label>
                                <InputMoney _label=" " readonly={true} onChange={(e) => { setBean({ ...bean, "AliveValue": e }) }} _value={bean.AliveValue} />
                            </div>
                            <div className="col-md-12">
                                <label>Observaciones</label>
                                <textarea className="form-control" name="Observations" value={bean.Observations} onChange={(e) => { setBean({ ...bean, "Observations": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('IDStore') ? 'has-error' : ''}`}>Ubicación</label>
                                <SelectStoreEditor label=" " idSelector={bean.IDStore} onChange={(e) => { setBean({ ...bean, "IDStore": e.IDStore }) }} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('Measurement') ? 'has-error' : ''}`}>Unidad de Medida</label>
                                <input type="text" className="form-control" name="Measurement" value={bean.Measurement} onChange={(e) => { setBean({ ...bean, "Measurement": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Vencimiento Garantía</label>
                                <InputDate notDate name="WarrantyDefeat" value={bean.WarrantyDefeat} setDate={(e) => { setBean({ ...bean, "WarrantyDefeat": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Serial</label>
                                <input type="text" className="form-control" name="SerialNumber" value={bean.SerialNumber} onChange={(e) => { setBean({ ...bean, "SerialNumber": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Código de Barras</label>
                                <input type="text" className="form-control" name="BarCode" value={bean.BarCode} onChange={(e) => { setBean({ ...bean, "BarCode": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('IDLine') ? 'has-error' : ''}`}>Línea de Producto</label>
                                {bean.IDLine}
                                <FixedAssetLineEditor _disable label=" " idSelector={bean.IDLine} onChange={(e) => {
                                    if (!bean.LiveTime) {
                                        setBean({ ...bean, "LiveTime": e.LiveTime, "IDLine": e.IDLine })
                                    } else {
                                        setBean({ ...bean, "IDLine": e.IDLine })
                                    }
                                }} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('FixedAssetAccountantID') ? 'has-error' : ''}`}>Clase de Producto</label>
                                <BranListForFixedAssetLineEditor label=" " idLine={bean.IDLine} idSelector={bean.FixedAssetAccountantID} onChange={(e) => { setBean({ ...bean, "FixedAssetAccountantID": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch _disable label="Generar Placa para cada uno" estado={bean.Disaggregate ?? false} eventChange={(e) => { setBean({ ...bean, "Disaggregate": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('LiveTime') ? 'has-error' : ''}`}>Tiempo de Depreciación</label>
                                <input type="number" className="form-control" name="LiveTime" value={bean.LiveTime} onChange={(e) => { setBean({ ...bean, "LiveTime": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Materialidad</label>
                                <BasicSwitch estado={bean.Materiality} eventChange={(e) => { setBean({ ...bean, "Materiality": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Mínima Cuantía</label>
                                <BasicSwitch estado={bean.MinAssetValue} eventChange={(e) => { setBean({ ...bean, "MinAssetValue": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Depreciable o Amortizable</label>
                                <BasicSwitch estado={bean.DepreciableOrAmortizeAsLine} eventChange={(e) => { setBean({ ...bean, "DepreciableOrAmortizeAsLine": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <InputMoney _label="Vr Sugerido Comercial" onChange={(e) => { setBean({ ...bean, "CommercialValue": e }) }} _value={bean.CommercialValue} />
                            </div>
                            <div className="col-md-6">
                                <label>Fecha de Adquisición/Compra</label>
                                <InputDate notDate name="AdquisitionDate" value={bean.AdquisitionDate} setDate={(e) => { setBean({ ...bean, "AdquisitionDate": e }) }} />
                            </div>
                        </div>
                    </Modal>
                </div>

                <div className="col-md-12">
                    <Modal modal={modalItems} updateModal={setModalItems} >
                        <div className="row">
                            <div className="col-md-12">
                                <FixedAssetItem isModal preFilterProps={{ IDFixedAsset: bean.IDFixedAsset }} />
                            </div>
                        </div>
                    </Modal>
                </div>

            </div>
        </BasicPage>
    )
}